import { render, staticRenderFns } from "./adminsetting.vue?vue&type=template&id=562b5e78"
import script from "./adminsetting.vue?vue&type=script&lang=js"
export * from "./adminsetting.vue?vue&type=script&lang=js"
import style0 from "./adminsetting.vue?vue&type=style&index=0&id=562b5e78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports